import { DateTime } from 'luxon';

const formatDate = (stringDate) =>
    DateTime.fromISO(stringDate).toLocaleString({ month: 'numeric', day: 'numeric', year: '2-digit' });
const formatDateTime = (stringDate) =>
    DateTime.fromISO(stringDate).toLocaleString({
        month: 'numeric',
        day: 'numeric',
        year: '2-digit',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
    });

const formatRemainingTime = (stringDate) =>
    DateTime.fromISO(stringDate).diff(DateTime.local(), ['years', 'months', 'days', 'hours', 'minutes']).values;

const formatDateTimeWithMs = (stringDate) =>
    DateTime.fromISO(stringDate).toLocaleString({
        month: 'numeric',
        day: 'numeric',
        year: '2-digit',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        fractionalSecondDigits: 3,
    });

export { DateTime, formatDate, formatDateTime, formatDateTimeWithMs, formatRemainingTime };
